import { render, staticRenderFns } from "./OoaSchoolChoices.vue?vue&type=template&id=14ac8076&"
import script from "./OoaSchoolChoices.vue?vue&type=script&lang=js&"
export * from "./OoaSchoolChoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports